module.exports = __webpack_public_path__ + "1793882494189/fonts/Flaticon.89ed3c6.ttf";